import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { IDiscountCode } from '@kinet-open-network/shared/data-access/model';

export class DiscountCode
  extends BaseModel<DiscountCode, 'DiscountCode'>
  implements IDiscountCode
{
  code!: string;
}
